import { createStyles, makeStyles } from "@material-ui/core"
import React from "react"
import { useTranslation } from "react-i18next";
import Badge from "../Badge";
import Logo from "../Logo";
import { SignupStepper } from "./SignupStepper";
import { useSignup } from "./state/SelfSignup";
// import YoelloLogo from '../../assets/images/yoello-logo.svg'l;

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            zIndex: 3,
            top: "0",
            left: "0",
            position: "fixed",
            padding: "4vh 2vw",
            width: "25%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: theme.palette.background.default,
            "@media only screen and (max-width: 960px)": {
                display: "none"
            },
        },
        text: {
            marginTop: "3rem",
            fontWeight: 700,
            fontSize: "3.5vh"
        },
        footer: {
            position: "absolute",
            bottom: "0",
            marginBottom: "3rem",
            marginLeft: "1rem",
            display: "flex",
            justifyContent: "center",
        },
    }))

export function SignupSidebar() {
    const classes = useStyles();
    const { host } = useSignup();
    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <Logo />
            {host === "partners" && <><p className={classes.text}>
                {t('signup.sidebar.sloganLine1')}
                {t('signup.sidebar.sloganLine2')}
            </p>
                <SignupStepper />
            </>}
            <div className={classes.footer}>
                <Badge text="" />
            </div>
        </div>
    )
}